import { Card } from '@zorro/design-system/v2/Card';
import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { Grid, Stack } from '@zorro/web/design-system';

export const PremiumAmountFormSkeleton = () => {
  return (
    <Card
      variant="white-border"
      style={(theme) => ({ borderColor: theme.colors.zorroGray[2] })}
    >
      <Grid gap="lg" h="6rem">
        <Grid.Col span={3}>
          <Skeleton h={16} w={130} />
        </Grid.Col>
        <Grid.Col span={3}>
          <Stack>
            <Skeleton h={26} w={70} />
            <Skeleton h={16} w={90} />
          </Stack>
        </Grid.Col>
        <Grid.Col span={3}>
          <Stack>
            <Skeleton h={26} w={70} />
            <Skeleton h={16} w={90} />
          </Stack>
        </Grid.Col>
        <Grid.Col span={3}>
          <Stack>
            <Skeleton h={26} w={70} />
            <Skeleton h={16} w={90} />
          </Stack>
        </Grid.Col>
      </Grid>
    </Card>
  );
};
